import {
  AssignConfig, getColorDefault,
  deepAssign, formatLogOption,
  getTooltipDefaultOption,
  getYAxisDefaultOption,
  getLegendDefaultOption,
  getXAxisDefaultOption
} from '@/utils/echarts-option/base'
import { applyEchartsFontToOption } from '@/utils/echarts-option/font'

/** grid（containLabel：Y 轴数值+单位较长时仍完整显示） */
export const GRID_BAR_OPTION = {
  top: 40,
  bottom: 30,
  left: 40,
  right: 20,
  containLabel: true,
}

/** legend */
export const LEGEND_BAR_OPTION = {
  top: -4,
  left: 0,
}

/** series */
export const SERIES_BAR_OPTION = {
  barWidth: 20,
  type: 'bar',
}

export function getBarOption (config = {} as AssignConfig) {
  return {
    color: getColorDefault(),
    grid: GRID_BAR_OPTION,
    legend: deepAssign(getLegendDefaultOption() , LEGEND_BAR_OPTION),
    xAxis: getXAxisDefaultOption(),
    series: SERIES_BAR_OPTION,
    yAxis: getYAxisDefaultOption(config),
    tooltip: getTooltipDefaultOption(config),
  }
}

export function getAssignBarOption (option: object, config: AssignConfig = {}) {
  option = formatLogOption(option, config)
  return applyEchartsFontToOption(
    deepAssign(getBarOption(config), option) as Record<string, unknown>,
  )
}
